import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './styles';
import { WarningIcon } from 'applicaiton/assets';
import SecondaryButton from '../SecondaryButton';
import { PathNames } from 'applicaiton/routes';
import { useNavigate } from 'react-router-dom';

const SubscriptionsBlocked: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(PathNames.clinicBilling);
  };

  return (
    <Wrapper>
      <div>
        <WarningIcon />
        <p>{t('subscription_warnings.blocked_text_1')}</p>
        <SecondaryButton onClick={handleClick}>
          {t('subscription_warnings.go_to_settings')}
        </SecondaryButton>
      </div>
    </Wrapper>
  );
};

export default SubscriptionsBlocked;
